import Debug from 'debug';
import _ from 'lodash';
const debug = Debug(`knack.core.helpers.filters.format`);
export const format = (submittedObject) => {
    debug(`FilterHelper: format()`);
    let objectToTransform = _.cloneDeep(submittedObject);
    debug(`FilterHelper: objectToTransform:`);
    debug(objectToTransform);
    if (_.isEmpty(objectToTransform)) {
        debug(`FilterHelper: submittedObject was empty, returning early with empty array`);
        return [];
    }
    if (typeof objectToTransform === `string`) {
        debug(`FilterHelper: objectToTransform was a string, attempting to JSON.parse it`);
        objectToTransform = JSON.parse(objectToTransform);
    }
    if (_.isEmpty(objectToTransform)) {
        debug(`FilterHelper: objectToTransform was empty, returning early with empty array`);
        return [];
    }
    if (_.isArray(objectToTransform)) {
        debug(`FilterHelper: objectToTransform is an array`);
        // This addresses menu filters where objectToTransform is actually
        // a rule instead of an entire filter structure object
        if (objectToTransform.length === 1 && !_.hasIn(objectToTransform[0], `match`)) {
            debug(`FilterHelper: objectToTransform contains a single item and does not have a match attribute, transforming and putting one in!`);
            objectToTransform = [
                {
                    match: `AND`,
                    rules: objectToTransform
                }
            ];
        }
    }
    else if (_.isObject(objectToTransform) && _.hasIn(objectToTransform, `match`) && _.hasIn(objectToTransform, `rules`)) {
        debug(`FilterHelper: objectToTransform is an object with filter format`);
        objectToTransform = [
            objectToTransform
        ];
    }
    debug(`FilterHelper: objectToTransform is:`);
    debug(objectToTransform);
    return objectToTransform;
};
